import "./Loader.css";

const Loader = () => {
  return (
    <div
      className="smarttt-page-loader"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="smarttt-page-loader__spinner" aria-hidden="true" />
    </div>
  );
};

export default Loader;
